import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";

function NtTelehealthSection({}) {
  const renderRow = (icon, text, containerStyle) => {
    return (
      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "white",
            padding: 18,
            borderRadius: 10,
          },
          containerStyle,
        ]}
      >
        <View
          style={{
            backgroundColor: "#dfdfdf",
            borderRadius: 20,
            padding: 8,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NtMaterialIcon name={icon} color={colors.almostBlack} />
        </View>

        <NtText
          style={{
            marginLeft: 6,
            fontSize: 12,
            fontWeight: "500",
            color: colors.almostBlack,
          }}
        >
          {text}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/c05bad910c6afb429d0e418cef3e249c59363d1f.jpg")}
    >
      <View
        style={{
          width: "100%",
          justifyContent: "center",
          flex: 1,
        }}
      >
        <NtSectionTitle style={{ textAlign: "left", fontSize: 28 }}>
          SHIPBOARD PASSENGERS &{"\n"}CREW HEALTH MONITORING
        </NtSectionTitle>
        <NtSectionDescription style={{ marginTop: 20 }}>
          Ensure safety at sea with our Shipboard Passenger & Crew Health
          Monitoring system. This solution tracks vital health data in real
          time, enabling early detection of symptoms, efficient response to
          health concerns, and compliance with maritime health
          regulations, protecting both guests and crew throughout the voyage.
        </NtSectionDescription>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 650,
  },
});

export default NtTelehealthSection;
